import type { default as Configure } from '@adonisjs/core/commands/configure'

/** @private */
export async function configure(command: Configure) {
  const codemods = await command.createCodemods()
  await codemods.updateRcFile((rcFile) => {
    rcFile.addProvider('@nhtio/lucid-resourceful/integration/provider')
  })
  await codemods.registerMiddleware('router', [
    {
      path: '@nhtio/lucid-resourceful/integration/middlewares/resourceful_encoded_request',
      position: 'after',
    },
  ])
}
